export const getBlobHotlinkUrl = (category: string, name: string) => {
  const pattern = import.meta.env.VITE_BLOB_STORAGE_URL_PATTERN || window.runtimeConfig.BLOB_STORAGE_URL_PATTERN;
  return pattern
    .replace('#CATEGORY#', category)
    .replace('#NAME#', name);
};

export const blobToBase64 = async (blob: Blob): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve((reader.result as string).slice((reader.result as string).lastIndexOf(',') + 1));
    };
    reader.readAsDataURL(blob);
  });
};

export const base64ToBlob = async (mimeType: string, content: string): Promise<Blob> => {
  if (mimeType.includes(';')) {
    mimeType = mimeType.slice(0, mimeType.indexOf(';'))
  }
  return await (await fetch(`data:${mimeType};base64,${content}`)).blob();
};
